import * as ModuleLoaderAmd from '@feature-hub/module-loader-amd';
import * as audiUiReactV2 from '@audi/audi-ui-react-v2';

import {
  definedExternals as _definedExternals,
  providedExternals as _providedExternals,
} from '@oneaudi/integrator-shared/externals-legacy';

export const definedExternals = {
  ..._definedExternals,
  '@audi/audi-ui-react': audiUiReactV2,
  '@audi/audi-ui-react-v2': audiUiReactV2,
  '@feature-hub/module-loader-amd': ModuleLoaderAmd,
};

export const providedExternals = {
  ..._providedExternals,
  /**
   * for absolute fail safety we're still gonna keep pretending that we have audi-ui-react v1, but we're gonna deliver v2 instead ;)
   * Can be removed when v2 is also removed
   */
  '@audi/audi-ui-react': '1.6.0',
  '@audi/audi-ui-react-v2': process.env.AUDI_UI_REACT_V2_VERSION as string,
  '@feature-hub/module-loader-amd': process.env.FEATURE_HUB_VERSION as string,
};
